function getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(+d);
    d.setHours(0, 0, 0, 0);
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    // Get first day of year
    var yearStart = new Date(d.getFullYear(), 0, 1);
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
    // Return array of year and week number
    return [d.getFullYear(), weekNo];
}
//calc the weeks in a year 
export function weeksInYear(year) {
    var month = 11,
        day = 31,
        week;

    // Find week that 31 Dec is in. If is first week, reduce date until
    // get previous week.
    do {
        let d = new Date(year, month, day--);
        week = getWeekNumber(d)[1];
    } while (week === 1);

    return week;
}
//setting the pay frequncey 
export function getPayFrequncey(payFreq, year) {
    let payfrequncey;
    switch (payFreq) {
    case "Daily":
        payfrequncey = 365
        break;
    case "Weekly":
        const weeks = weeksInYear(year);
        console.log("weeks number:", weeks);
        payfrequncey = weeks;
        break;
    case "Bi-weekly":
        let biWeeks = weeksInYear(year);
        biWeeks = Math.ceil(biWeeks / 2);
        console.log("bi-wees:", biWeeks);
        payfrequncey = biWeeks;
        break;
    case "Monthly":
        payfrequncey = 12
        break;
    case "Semi-monthly":
        payfrequncey = 24;
        break;
    case "Quarterly":
        payfrequncey = 4
        break;
    case "Semi-annually":
        payfrequncey = 2
        break;
    case "Annually":
        payfrequncey = 1
        break;
    default:
        break;
    }

    return payfrequncey;
}
export function getDaysAmount(payFreq) {
    let payfrequncey;
    switch (payFreq) {
    case "Daily":
        payfrequncey = 1
        break;
    case "Weekly":
        payfrequncey = 7;
        break;
    case "Bi-weekly":
        payfrequncey = 14;
        break;
    case "Monthly":
        payfrequncey = 30;
        break;
    case "Semi-monthly":
        payfrequncey = 15;
        break;
    case "Quarterly":
        payfrequncey = 90;
        break;
    case "Semi-annually":
        payfrequncey = 180;
        break;
    case "Annually":
        payfrequncey = 365;
        break;
    default:
        break;
    }

    return payfrequncey;
}

//if the employee hired this year calc the moths from date hired till the current paycheck month 
export function dateRange(startDate, endDate) {
    // console.log("one:", startDate, "two:", endDate);
    if (!endDate || !startDate) {
        return
    }
    let Nomonths;
    Nomonths = (endDate.getFullYear() - startDate.getFullYear()) * 12;
    Nomonths -= startDate.getMonth() + 1;
    Nomonths += endDate.getMonth() + 1; // we should add + 1 to get correct month number
    return Nomonths <= 0 ? 1 : Nomonths + 1;
}

export function getCurrencySign(currency) {
    let currencySign = '';
    if (currency === 'United Kingdom Pound') {
        currencySign = '£';
    } else if (currency === 'United States Dollar') {
        currencySign = '$';
    } else if (currency === 'Euro Member Countries') {
        currencySign = '€';
    } else if (currency === 'Israel Shekel') {
        currencySign = '₪';
    } else {
        currencySign = `${currency} `;
    }

    return currencySign;
}